import './popupmodal.less'

import {Icon} from '@codeurs/front'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import Modal from '@material-ui/core/Modal'
import React, {useContext} from 'react'
import {Mod, style} from 'util/style'

const styles = style('popupmodal', [
	'block',
	'top',
	'content',
	'footer',
	'title',
	'left',
	'right',
	'message'
])

/**
 * Example:
 *
 * ```typescript
 * const Popup = () => {
 *   const [open, setOpen] = useState(true)
 *   return <PopupModal open={open} onClose={() => setOpen(false)}>
 *     <PopupModal.Title>Thank you</PopupModal.Title>
 *     <PopupModal.Message>Your email was submitted.</PopupModal.Message>
 *   </PopupModal>
 * }
 * ```
 */
const PopupContext = React.createContext(null)

export const PopupModal = ({open = true, onClose, children}) => (
	<Modal
		open={open}
		onClose={onClose}
		BackdropComponent={Backdrop}
		BackdropProps={{
			timeout: 500
		}}
		{...styles()}
	>
		<Fade in={open} timeout={500}>
			<div className={styles('content')}>
				<PopupContext.Provider value={{onClose}}>
					{children}
				</PopupContext.Provider>
			</div>
		</Fade>
	</Modal>
)

PopupModal.Block = ({children}) => (
	<div className={styles.block()}>{children}</div>
)

const Top: React.FC = ({children}) => (
	<div className={styles.top()}>{children}</div>
)
PopupModal.Top = Top

const Content: React.FC<{mod?: Mod<'big'>}> = ({children, mod}) => {
	const popup = useContext(PopupContext)

	return (
		<div className={styles.content().mod(mod)}>
			<a onClick={popup.onClose} className={styles.content('close')}>
				<Icon icon="close" />
			</a>
			{children}
		</div>
	)
}
PopupModal.Content = Content

const Footer: React.FC = ({children}) => (
	<div className={styles.footer()}>{children}</div>
)
PopupModal.Footer = Footer

const Message: React.FC<{
	mod?: Mod<'fullwidth'>
}> = ({mod, children}) => (
	<div className={styles.message().mod(mod)}>{children}</div>
)
PopupModal.Message = Message

const Left: React.FC = ({children}) => (
	<div className={styles.left()}>{children}</div>
)
PopupModal.Left = Left

const Right: React.FC = ({children}) => (
	<div className={styles.right()}>{children}</div>
)
PopupModal.Right = Right
